var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full h-full"},[_c('iframe',{ref:"iframe",staticClass:"w-full h-full",attrs:{"frameboder":"0","src":("/runner.html?siteID=" + (_vm.$route.params.siteID))}})])}
var staticRenderFns = []

export { render, staticRenderFns }